import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHome, FiMonitor, FiShoppingCart, FiSettings, FiGamepad2 } = FiIcons;

function Navigation() {
  const location = useLocation();

  const navItems = [
    { path: '/', icon: FiHome, label: 'Dashboard' },
    { path: '/stations', icon: FiMonitor, label: 'Stationen' },
    { path: '/kiosk', icon: FiShoppingCart, label: 'Kiosk Bestellungen' },
    { path: '/settings', icon: FiSettings, label: 'Einstellungen' }
  ];

  return (
    <nav className="fixed left-0 top-0 h-full w-64 bg-gray-900 text-white shadow-lg z-10">
      <div className="p-6 border-b border-gray-700">
        <div className="flex items-center space-x-3">
          <SafeIcon icon={FiGamepad2} className="text-2xl text-blue-400" />
          <h1 className="text-xl font-bold">Game Lounge</h1>
        </div>
      </div>
      
      <div className="mt-6">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center space-x-3 px-6 py-3 hover:bg-gray-800 transition-colors ${
                isActive ? 'bg-blue-600 border-r-4 border-blue-400' : ''
              }`}
            >
              <SafeIcon icon={item.icon} className="text-lg" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

export default Navigation;